<template>
    <div
        v-if="!loading"
        class="menu-area__categories__tags">
        <div
            v-for="(tagsParent, index) of orderedTagsParents"
            :key="index">
            <p>{{ tagsParent.fields.title }}</p>
            <ul>
              <li
                  v-for="(tag, index) of $_filterEntriesByTagParentTitle(tagsParent.fields.title)"
                  :key="index">
                  <router-link 
                  :class="'underline_link'" 
                  :to="{ name: 'single-tag', params: { slug: tag.fields.slug } }">
                  {{ tag.fields.title }}
                  </router-link>
              </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TagsByParentsList',
  data: () => ({
    loading: true,
  }),
  computed: {
    ...mapGetters('contentful', [
      'tagsParents',
      'tags'
    ]),
    orderedTagsParents: {
      get () {
        if (this.loading) return []
        return this.tagsParents
        /*
        return this.tagsParents.sort((a, b) => {
          if (a.fields.order < b.fields.order) return -1
          if (a.fields.order > b.fields.order) return 1
          return 0
        })
        */
      }
    },
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadTagsParents',
      'loadTags'
    ]),
    $_filterEntriesByTagParentTitle (tagTitle) {
      return this.tags
        .filter(t => typeof t.fields.parentGroup !== 'undefined')
        .filter(t => tagTitle === t.fields.parentGroup.fields.title)
    },
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadTagsParents(), this.loadTags()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>
